// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getMonth as fn } from "../getMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getMonthWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getMonthWithOptions;
